export const KIEM_KE_PERMISSION_CODES = {
  WEB_BH_KIEM_KE_LIST: 'WEB_BH_KIEM_KE_LIST',
  WEB_BH_KIEM_KE_DETAIL: 'WEB_BH_KIEM_KE_DETAIL',
  WEB_BH_KIEM_KE_ADD: 'WEB_BH_KIEM_KE_ADD',
  WEB_BH_KIEM_KE_EDIT: 'WEB_BH_KIEM_KE_EDIT',
  WEB_BH_KIEM_KE_DELETE: 'WEB_BH_KIEM_KE_DELETE',
  WEB_BH_KIEM_KE_COMPLETE: 'WEB_BH_KIEM_KE_COMPLETE',
  WEB_BH_KIEM_KE_CANCEL: 'WEB_BH_KIEM_KE_CANCEL',
  WEB_BH_KIEM_KE_EXPORT: 'WEB_BH_KIEM_KE_EXPORT',
  WEB_BH_KIEM_KE_IMPORT: 'WEB_BH_KIEM_KE_IMPORT',
  WEB_BH_KIEM_KE_COPY: 'WEB_BH_KIEM_KE_COPY',
} as const

export const KIEM_KE_MUTATE_PERMISSIONS = [
  KIEM_KE_PERMISSION_CODES.WEB_BH_KIEM_KE_ADD,
  KIEM_KE_PERMISSION_CODES.WEB_BH_KIEM_KE_EDIT,
  KIEM_KE_PERMISSION_CODES.WEB_BH_KIEM_KE_DELETE,
  KIEM_KE_PERMISSION_CODES.WEB_BH_KIEM_KE_COMPLETE,
  KIEM_KE_PERMISSION_CODES.WEB_BH_KIEM_KE_CANCEL,
  KIEM_KE_PERMISSION_CODES.WEB_BH_KIEM_KE_EXPORT,
  KIEM_KE_PERMISSION_CODES.WEB_BH_KIEM_KE_IMPORT,
  KIEM_KE_PERMISSION_CODES.WEB_BH_KIEM_KE_COPY,
] as const
